import { Label } from "@radix-ui/react-dropdown-menu";
import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DropdownMenuLabelProps } from "../types";

function DropdownMenuLabel({
  inset,
  className,
  ...props
}: DropdownMenuLabelProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Label
      data-slot="dropdown-menu-label"
      data-inset={inset}
      className={cn(
        "px-2 py-1.5 text-sm font-medium",
        inset && "pl-8",
        className,
        classes,
      )}
      {...native}
    />
  );
}

DropdownMenuLabel.displayName = "DropdownMenu.Label";

export default DropdownMenuLabel;
